import api from './api';

export const getAsignaciones = (tipo = 'trianual') => {
  return api.get(`/api/evento_evaluacion/asignaciones?tipo=${tipo}`);
};
